import { z } from 'zod';

export const ConfigCategorySchema = z.enum([
  'FEATURE_FLAG',
  'BUSINESS_RULE',
  'INTEGRATION',
  'INFRASTRUCTURE',
  'SECURITY',
  'GENERAL',
]);
export type ConfigCategory = z.infer<typeof ConfigCategorySchema>;

export const ConfigValueTypeSchema = z.enum([
  'STRING',
  'NUMBER',
  'BOOLEAN',
  'JSON',
  'ENCRYPTED',
]);
export type ConfigValueType = z.infer<typeof ConfigValueTypeSchema>;

export const CreateConfigItemSchema = z.object({
  key: z.string().min(1).max(200),
  category: ConfigCategorySchema,
  valueType: ConfigValueTypeSchema,
  value: z.union([z.boolean(), z.string(), z.number(), z.record(z.unknown())]),
  displayName: z.string().max(200).optional(),
  description: z.string().max(500).optional(),
  isSecret: z.boolean().optional(),
  isReadOnly: z.boolean().optional(),
  validationRule: z.string().optional(),
  environment: z.string().optional(),
});
export type CreateConfigItemInput = z.infer<typeof CreateConfigItemSchema>;

export const UpdateConfigItemSchema = z.object({
  value: z.union([z.boolean(), z.string(), z.number(), z.record(z.unknown())]),
  reason: z.string().min(1),
});
export type UpdateConfigItemInput = z.infer<typeof UpdateConfigItemSchema>;

export const RollbackConfigSchema = z.object({
  targetVersion: z.number().int().positive(),
  reason: z.string().min(1),
});
export type RollbackConfigInput = z.infer<typeof RollbackConfigSchema>;
